import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const productApi = createApi({
    reducerPath: 'productApi',
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['Product'],
    endpoints: builder => ({

        getAllProducts: builder.query({
            query: () => `/anuyog-products-list/`,
            providesTags: ['Product'],
        }),

        getProductBySlug: builder.query({
            query: slug => `/product-by-slug/${slug}/`,
            providesTags: ['Product'],
        }),

        createProduct: builder.mutation({
            query: formData => ({
                url: `/anuyog-create-product/`,
                method: 'POST',
                body: formData,
            }),
        }),

        updateProduct: builder.mutation({
            query: ({ slug, formData }) => ({
                url: `/anuyog-update-product/${slug}/`,
                method: 'PATCH',
                body: formData,
            }),
            invalidatesTags: ['Product'],
        }),

        deleteProduct: builder.mutation({
            query: slug => ({
                url: `/anuyog-delete-product/${slug}/`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Product'],
        }),
    }),
});

export const {
    useGetAllProductsQuery,
    useGetProductBySlugQuery,
    useCreateProductMutation,
    useUpdateProductMutation,
    useDeleteProductMutation,
} = productApi;
